"use strict";

exports.__esModule = true;
exports.TriggerText = exports.TooltipRoot = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _themes = require("../themes");

var _Popover = _interopRequireDefault(require("../Popover"));

var _themes2 = require("./themes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TooltipRoot = (0, _themes.themed)(_Popover["default"])(function (_ref) {
  var baseTheme = _ref.theme;
  return (0, _themes.mapComponentThemes)({
    name: 'Tooltip',
    theme: (0, _themes2.tooltipTheme)(baseTheme)
  }, {
    name: 'Popover',
    theme: {}
  }, baseTheme);
});
exports.TooltipRoot = TooltipRoot;
var TriggerText = (
/*#__PURE__*/
0, _styledBase["default"])('span', {
  target: "e3ztgjb0"
})(function (_ref2) {
  var baseTheme = _ref2.theme;
  var theme = (0, _themes2.tooltipTheme)(baseTheme);
  return {
    borderBottomStyle: theme.TooltipTriggerText_borderStyle,
    borderBottomColor: theme.TooltipTriggerText_borderColor,
    borderBottomWidth: theme.TooltipTriggerText_borderWidth
  };
});
exports.TriggerText = TriggerText;